import styles from "./Instructions.module.scss";
import { FormattedMessage } from "react-intl";
import hasInstructions from "./hasInstructions";
import EditAttachment from "../../../../common/icons/EditAttachment.tsx";
import DisplayNotes from "./common/DisplayNotes";
import { CourseMaterial } from "./coursesLoader";
import InstructionAttachmentsDialog from "./InstructionAttachmentsDialog";
import { useState } from "react";
import { Attachment } from "common/api/decimal/methods/course";

const InstructionAttachments = ({
  attachments,
}: {
  attachments?: Attachment[];
}) => {
  const [openAttachmentsDialog, setOpenAttachmentsDialog] =
    useState<boolean>(false);
  const attachmentsCount = attachments?.length ?? 0;
  if (!attachments || attachmentsCount === 0) {
    return null;
  }

  return (
    <>
      <div className={styles.instructionAttachments}>
        <EditAttachment className={styles.attachmentIcon} />
        <span className={styles.attachmentLabel}>
          <FormattedMessage
            defaultMessage="{count, plural, =1 {# Attachment} other {# Attachments}}"
            values={{ count: attachmentsCount }}
          />
        </span>
        <button
          type="button"
          className="vst-link vst-link-size-small"
          onClick={() => setOpenAttachmentsDialog(true)}
        >
          <FormattedMessage defaultMessage="View" />
        </button>
      </div>
      {openAttachmentsDialog && (
        <InstructionAttachmentsDialog
          attachments={attachments}
          onRequestClose={() => setOpenAttachmentsDialog(false)}
        />
      )}
    </>
  );
};

export default function Instructions({
  attachments,
  displayNotes,
}: Pick<CourseMaterial, "attachments" | "displayNotes">) {
  const showInstructions = hasInstructions({
    attachments,
    displayNotes,
  });

  return (
    <>
      {showInstructions ? (
        <div className={styles.container} data-testid="material-instructions">
          <h3 className={styles.containerTitle}>
            <FormattedMessage defaultMessage="Instructions" />
          </h3>

          {displayNotes && (
            <DisplayNotes
              displayNotes={displayNotes}
              className={styles.displayNotes}
            />
          )}
          <InstructionAttachments attachments={attachments} />
        </div>
      ) : null}
    </>
  );
}
